import { plainToClass } from 'class-transformer';
import {
  API_SERVICE_TYPE_CREATE,
  API_SERVICE_TYPE_DELETE,
  API_SERVICE_TYPE_FIND_ALL,
  API_SERVICE_TYPE_FIND_ONE,
  API_SERVICE_TYPE_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { ServiceTypeDto } from '../dto';
import { FindAllResponse } from '../types';

export class ServiceTypeApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<ServiceTypeDto>> {
    return this.httpClient
      .get(API_SERVICE_TYPE_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(ServiceTypeDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<ServiceTypeDto> {
    return this.httpClient
      .get(API_SERVICE_TYPE_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(ServiceTypeDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<ServiceTypeDto> {
    return this.httpClient
      .post(API_SERVICE_TYPE_CREATE, data)
      .then(({ data }) => {
        return plainToClass(ServiceTypeDto, data);
      });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<ServiceTypeDto> {
    return this.httpClient
      .put(API_SERVICE_TYPE_UPDATE, data)
      .then(({ data }) => {
        return plainToClass(ServiceTypeDto, data);
      });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_SERVICE_TYPE_DELETE, {
      pathParams: { uuid }
    });
  }
}
